import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
  },
  edit: {
    marginLeft: "auto",
    fontSize: 16
  },
  card: {
    margin: "0 auto",
    width: "90%",
    [theme.breakpoints.up("sm")]: {
      padding: 5,
      width: "60%",
      margin: "0 auto"
    }
  },
  header: {
    fontSize: 14,
    fontWeight: 600,
    color: "#75070d"
  },
  text: {
    fontSize: 14
  }
}));

export default function PersonalDetails({
  email,
  address,
  suburb,
  city,
  phone
}) {
  const classes = useStyles();

  const updateDetails = () => {
    alert("Editing is not currently enabled");
    // this will need to direct the user to a page similar to the register page without password details
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.CardContent}>
        <Typography
          variant="body2"
          color="textSecondary"
          className={classes.header}
        >
          {email}
          <IconButton aria-label="edit" onClick={updateDetails}>
            <EditIcon className={classes.edit} />
          </IconButton>
        </Typography>

        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.text}
        >
          {address}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.text}
        >
          {suburb}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.text}
        >
          {city}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
          className={classes.text}
        >
          {phone}
        </Typography>
      </CardContent>
    </Card>
  );
}
